(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["price"] && !Shopify.designMode) return;
  try {
    (function () {
  function formatMoney(cents) {
  var amount = (cents / 100).toFixed(2);
  if (window.moneyFormat) {
    return window.moneyFormat
      .replace('{{amount}}', amount)
      .replace('{{amount_no_decimals}}', Math.round(cents / 100))
      .replace('{{amount_with_comma_separator}}', amount.replace('.', ','));
  }
  return amount;
}

  function updatePrice(variantId) {
    if (!window.productJSON) return;
    var variant = window.productJSON.variants.find(function (v) {
      return v.id == variantId;
    });
    if (!variant) return;

    document.querySelectorAll('product-price .sale-price').forEach(function (el) {
      el.textContent = formatMoney(variant.price);
    });

    var hasDiscount = variant.compare_at_price && variant.compare_at_price > variant.price;

    document.querySelectorAll('product-price .compare-price').forEach(function (el) {
      el.textContent = hasDiscount ? formatMoney(variant.compare_at_price) : '';
      el.style.display = hasDiscount ? '' : 'none';
    });

    document.querySelectorAll('product-price .discount-badge').forEach(function (el) {
      if (hasDiscount) {
        var pct = Math.round(((variant.compare_at_price - variant.price) * 100) / variant.compare_at_price);
        el.textContent = pct + '% OFF';
        el.style.display = '';
      } else {
        el.style.display = 'none';
      }
    });
  }

  function getVariantFromURL() {
    return new URLSearchParams(window.location.search).get('variant');
  }

  // URL change intercept (Shopify variant select yahi karta hai)
  ['pushState', 'replaceState'].forEach(function (method) {
    var orig = history[method];
    history[method] = function () {
      orig.apply(this, arguments);
      setTimeout(function () {
        var v = getVariantFromURL();
        if (v) updatePrice(v);
      }, 50);
    };
  });

  window.addEventListener('popstate', function () {
    var v = getVariantFromURL();
    if (v) updatePrice(v);
  });

  // Shopify theme custom event fallback
  document.addEventListener('variant:change', function (e) {
    if (e.detail && e.detail.variant) updatePrice(e.detail.variant.id);
  });
})();
  } catch(e) { console.error(e); }
})();

})();
